import React from 'react';
import classNames from 'classnames';

import { useAppSelector } from 'client/hooks';
import { selectUserRoomRole } from 'client/redux/client/selectors';
import { selectIsShowFooterPopUp } from 'client/redux/ui/selectors';

import AdminActionsPanel from './Panels/AdminActionsPanel';
import SpeakerActionsPanel from './Panels/SpeakerActionsPanel';
import ListenerActionsPanel from './Panels/ListenerActionsPanel';
import TransitionComponent from '../TransitionComponent';
import { TermsFooter } from '../TermsFooter';

import css from './Footer.module.scss';

interface Props {
  className?: string;
  roomId: string;
}

const Footer: React.FC<Props> = ({ className = '', roomId }) => {
  const isShowFooterPopUp = useAppSelector(selectIsShowFooterPopUp);
  const userRole = useAppSelector((state) => selectUserRoomRole(state, roomId));

  const renderButtons = React.useCallback(() => {
    switch (userRole) {
      case 'admin':
        return <AdminActionsPanel roomId={roomId} userRole={userRole} />;
      case 'host':
        return <AdminActionsPanel roomId={roomId} userRole={userRole} />;
      case 'speaker':
        return <SpeakerActionsPanel />;
      default: // listener
        return <ListenerActionsPanel />;
    }
  }, [roomId, userRole]);

  return (
    <div className={classNames(css.footer, className)}>
      <TransitionComponent type="opacity" visible={isShowFooterPopUp}>
        <div className={classNames(css.popupOverlay)}></div>
      </TransitionComponent>

      <div className={css.container}>
        {renderButtons()}
        <TermsFooter className={css.termsFooter} />
      </div>
    </div>
  );
};

export default Footer;
